import React, { Component } from "react";
import { makeID } from "./components/helper";
//import logo from "./logo.svg";
import "./App.css";
import Questions from "./components/questions";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import Login from "./components/login";
import "@babel/polyfill";


//var debug = require("debug");

class App extends Component {
  state = {
    prihlaseno: false,
    odstartovano: false,
    start: Date.now(),
    krok: -1,
    penale: -1
  };

  constructor() {
    super();
    var config = {
      apiKey: "AIzaSyCsjqMPPm0ksRRi2p_CqbSR_AFmMBzZ6KE",
  authDomain: "webtest-89b93.firebaseapp.com",
  databaseURL: "https://webtest-89b93.firebaseio.com",
  projectId: "webtest-89b93",
  storageBucket: "webtest-89b93.appspot.com",
  messagingSenderId: "24924949895",
  appId: "1:24924949895:web:eca76ab371920401555722",
      measurementId: "G-V3ED6NYTCM"
    };
    firebase.initializeApp(config);
    this.readUserData = this.readUserData.bind(this);
    //this.writeUserData("aadd@bb.cz", "aa", "bb");
  }

  // writeUserDataSingle(email, fname, lname) {
  //   firebase
  //     .database()
  //     .ref("Hry/")
  //     .set({
  //       email,
  //       fname,
  //       lname
  //     })
  //     .then(data => {
  //       //success callback
  //       //console.log("data ", data);
  //     })
  //     .catch(error => {
  //       //error callback
  //       //console.log("error ", error);
  //     });
  // }

  // writeUserData(email, fname, lname) {
  //   firebase
  //     .database()
  //     .ref("Hry/")
  //     .push({
  //       email,
  //       fname,
  //       lname
  //     })
  //     .then(data => {
  //       //success callback
  //       //console.log("data ", data);
  //     })
  //     .catch(error => {
  //       //error callback
  //       //console.log("error ", error);
  //     });
  // }

  // updateSingleData(email) {
  //   firebase
  //     .database()
  //     .ref("Hry/")
  //     .update({
  //       konec: Date.now()
  //     });
  // }

  // InfoClicked = () => {
  //   this.setState({ odstartovano: true });

  //   var user = firebase.auth().currentUser;
  //   this.updateSingleData(user.email);
  // };

  render() {
    //db = firebase;
    //console.log("DB", firebase);
    return (
      <React.Fragment>
        <div className="container-fluid">{this.renderObsah()}</div>
      </React.Fragment>
    );
  }

  renderObsah = () => {
    //debug("AAA", "BBB");
    //debug("App.js renderObsah ", this.state);
    //return <Questions />;
    if (this.state.prihlaseno === false)
      return <Login onLogin={this.handleLogin} />;
    else {
      if (this.state.krok >= 0 && this.state.penale >= 0)
        return (
          <Questions
            start={this.state.start}
            krok={this.state.krok}
            penale={this.state.penale}
          />
        );

      //if (this.state.odstartovano) return <Questions />;
      //else return <Info onClick={this.InfoClicked} />;
    }
  };

  handleLogin = error => {
    //console.log("Handle login aa:", error);
    if (error == null) {
      //console.log("handle login");
      this.readUserData();
      this.setState({ prihlaseno: true });
    } else {
      this.setState({ prihlaseno: false });
      //console.log(error);
    }
  };

  readUserData() {
    //console.log("Read user data");
    var user = firebase.auth().currentUser;
    firebase
      .database()
      .ref("Hry/" + makeID(user))
      .once("value", snapshot => {
        if (snapshot.val() != null) {
          if (snapshot.val().start != null)
            this.setState({ start: snapshot.val().start });
          else this.setState({ start: Date.now() });

          if (snapshot.val().krok != null)
            this.setState({ krok: snapshot.val().krok });
          else this.setState({ krok: 0 });

          if (snapshot.val().penale != null)
            this.setState({ penale: snapshot.val().penale });
          else this.setState({ penale: 0 });
        } else {
          this.setState({ start: Date.now() });
        }
      });
  }

  // makeID = user => {
  //   let vysledek = user.email.replace("@", "(at)").replace("/./g", "(tecka)");
  //   console.log("Hledam" + vysledek);
  //   return vysledek;
  // };

  ZapisLogin() {
    //console.log("Zapis login");
    var now = new Date();
    var todayUTC = new Date(
      Date.UTC(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        now.getHours(),
        now.getMinutes(),
        now.getSeconds()
      )
    );
    var cas = todayUTC.toISOString();
    var user = firebase.auth().currentUser;
    firebase
      .database()
      .ref("Hry/")
      .child(makeID(user))
      .update({
        email: user.email,
        zacatek: cas,
        start: Date.now()
      })
      .then(data => {
        //success callback
        //console.log("data ", data);
      })
      .catch(error => {
        //error callback
        //console.log("error ", error);
      });
  }
}

export default App;
